module.exports = __webpack_public_path__ + "3cf3e6b8fcd98bd670c5b3a390585c05.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-emo-s.png
// module id = 2830
// module chunks = 0